import { getRequest } from '.'

export const getRealms = async (): Promise<wowaudit.Realm[]> => {
  return await getRequest(`/api/realms`)
}
